import React from "react";

export default function Box({ _id, onDelete, onEdit, onVisibilityChange, ...props }) {
  const dataToEdit = { ...props };
  delete dataToEdit.path;
  delete dataToEdit.createdAt;
  delete dataToEdit.updatedAt;
  delete dataToEdit.__v;
  return (
    <div className="box-data-main">
      <button onClick={() => onEdit({ ...dataToEdit, _id })}>Edit</button>
      <button onClick={() => onDelete(_id)}>Delete</button>
      <button onClick={() => onVisibilityChange(_id, dataToEdit.status == "hidden" ? "show" : "hidden")}>{dataToEdit.status == "hidden" ? "Show" : "Hide"}</button>
      <button onClick={() => window.open(process.env.REACT_APP_MOFA_PREFIX + props.name + ".pdf", "_blank")}>View</button>
      <p>
        <strong>Name:</strong> {props.name}
      </p>
    </div>
  );
}
